<template>
    <div>
        <Container class="px-[18px]">
            <h2 class="text-[28px] mb-[17px] font-bold">Customized Regional Hubs</h2>
<!--            custom rendered-content css styling to allow proper list indentation-->
            <div class="rendered-content" v-html="content"></div>

            <div class="grid grid-cols-3 md:grid-cols-4 gap-x-2 gap-y-4 mt-[34px]">
                <div class="flex flex-col items-center">
                    <img
                        :src="regionOneImageSrc"
                        loading="lazy"
                        alt=""
                        class="rounded-lg block mx-auto"
                        :style="{
                            'width': isMobile ? `${mobileImageWidth}%` : `${imageWidth}px`,
                            'height': isMobile ? `${mobileImageHeight}px` : `${imageHeight}px`,
                            'object-fit': 'cover'
                        }"
                    />

                    <h5 class="my-2 text-lg">{{ regionOneHeading }}</h5>
                </div>

                <div class="flex flex-col items-center">
                    <img
                        :src="regionTwoImageSrc"
                        loading="lazy"
                        alt=""
                        class="rounded-lg block mx-auto"
                        :style="{
                            'width': isMobile ? `${mobileImageWidth}%` : `${imageWidth}px`,
                            'height': isMobile ? `${mobileImageHeight}px` : `${imageHeight}px`,
                            'object-fit': 'cover'
                        }"
                    />

                    <h5 class="my-2 text-lg">{{ regionTwoHeading }}</h5>
                </div>

                <div class="flex flex-col items-center">
                    <img
                        :src="regionThreeImageSrc"
                        loading="lazy"
                        alt=""
                        class="rounded-lg block mx-auto"
                        :style="{
                            'width': isMobile ? `${mobileImageWidth}%` : `${imageWidth}px`,
                            'height': isMobile ? `${mobileImageHeight}px` : `${imageHeight}px`,
                            'object-fit': 'cover'
                        }"
                    />

                    <h5 class="my-2 text-lg">{{ regionThreeHeading }}</h5>
                </div>

                <div class="col-span-3 md:col-span-1 flex flex-col my-auto">
                    <div v-html="partnerMessage"></div>
                    <button
                        class="w-fit outline outline-[#556FA4] rounded-xl py-2 px-2 cursor-pointer my-4 text-[#556FA4] font-bold inline-flex items-center whitespace-no-wrap"
                        @click="navigateTo"
                    >
                        <span class="block text-left ">
                             Contact Us about <br class="hidden md:block"> state partnerships
                        </span>


                        <ArrowRightIcon class="text-[#556FA4] w-10 h-10 ml-4 md:ml-0" />
                    </button>

                </div>


            </div>
        </Container>
    </div>

</template>
<script>
import Container from "../../../../Layouts/Container.vue";
import { ArrowRightIcon } from "@heroicons/vue/solid";

export default {
    components: { Container, ArrowRightIcon },
    computed: {},
    data() {
        return {
            isMobile: typeof window !== 'undefined' ? window.innerWidth < 768 : (this.$page?.props?.isMobileUA ?? false)
        };
    },
    methods: {
        navigateTo() {
            window.open(this.buttonLink, this.openNewTab ? "_blank" : "_self");
        }
    },
    props: {
        content: {
            type: String,
            default: `<p>
                  We partner with education stakeholders to create customized regional hubs for climate education, featuring:
                </p>
                <ul>
                  <li>A unique URL and landing page</li>
                  <li>State-aligned resources from our core platform</li>
                  <li>Additional state-specific teaching materials and professional learning</li>
                  <li>Lesson plans crafted by local educators</li>
                </ul>
                `
        },
        regionOneImageSrc: {
            type: String,
            default: null
        },
        regionOneHeading: {
            type: String,
            default: null
        },
        regionTwoImageSrc: {
            type: String,
            default: null
        },
        regionTwoHeading: {
            type: String,
            default: null
        },
        regionThreeImageSrc: {
            type: String,
            default: null
        },
        regionThreeHeading: {
            type: String,
            default: null
        },
        mobileImageWidth: {
            type: Number,
            default: 100
        },
        imageWidth: {
            type: Number,
            default: 100
        },
        mobileImageHeight: {
            type: Number,
            default: 100
        },
        imageHeight: {
            type: Number,
            default: 100
        },
        partnerMessage: {
            type: String,
            default: "We are excited to partner with additional states and regions looking to implement climate education in their schools."
        },
        buttonLink: {
            type: String,
            default: null
        },
        openNewTab: {
            type: Boolean,
            default: false
        },
    }
};
</script>

<style >
.rendered-content ol,
.rendered-content ul {
    list-style: revert !important;
    padding-left: 1.5rem !important;
}


</style>
